@if (entry?.base?.display) {
  <div [connect]="'payloadStates.' + entry?.formControlAttributes?.connectPath" class="form-container">
    <div class="form-description">
      If you are the authorized representative, please sign above and print below.
    </div>
    <form>
      <div class="form-field-container">
        <div class="form-field-label">Representative's Name</div>
        <mat-form-field appearance="outline">
          <input matInput placeholder="Type name" />
        </mat-form-field>
      </div>
      <div class="form-field-container">
        <div class="form-field-label">Your Relationship to the Beneficiary</div>
        <mat-form-field appearance="outline">
          <input matInput placeholder="Example: Daughter" />
        </mat-form-field>
      </div>
    </form>
  </div>
}
